import { render, staticRenderFns } from "./CreateTableFromCustomerDialog.vue?vue&type=template&id=788b0c4f&"
import script from "./CreateTableFromCustomerDialog.vue?vue&type=script&lang=js&"
export * from "./CreateTableFromCustomerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports